<!--
 * @Description: 
-->
<!--
 * @Description: 
-->

<template>
	<div>
		<page-header :tabIndex="4" />
		<div :style="'background: url('+detail.banner+');padding-top:100px;box-sizing:border-box'" class="banner-box" >
			<div style="width:1200px;margin:0 auto;">
				<div class="s-name">{{detail.schemeName}}</div>
				<div class="s-desc">{{detail.schemeDescribe}}</div>

			</div>
	    </div>
		<div class="cad-box">
			<div class="cad-title">需求背景</div>
			<div class="cad-imgs">
				<img v-for="(item, index) in detail.backgroundTempArr" :key="index" v-lazy="item" alt="" />
			</div>
		</div>
		<div class="cad-box">
			<div class="cad-title">方案架构</div>
			<img v-for="(item, index) in detail.frameworkTempArr" :key="index" v-lazy="item" alt="" />
		</div>
		<div class="cad-box">
			<div class="cad-title" style="margin-bottom: 30px">方案优势</div>
			<div class="good-box" v-for="(item, index) in detail.advantageTempArr" :key="index">
				<img v-lazy="item" alt="" />
			</div>
		</div>
		<page-foot></page-foot>
	</div>
</template>
<script>
import pageHeader from "../../components/pageHeader.vue";
import pageFoot from "../../components/pageFoot.vue";
export default {
	name: "plan",
	components: { pageHeader, pageFoot },

	data() {
		return {		
			planId: null,
			detail: {
                backgroundTempArr:[],
                frameworkTempArr:[],
                advantageTempArr:[],
            },
		};
	},
	created() {
		
		this.planId = this.$route.query.id;
		this.getPlanListData();
	},
	mounted() {
		
	},
	methods: {
		getPlanListData() {
			this._get(this.API.planList+'?pageNo=1&pageSize=100').then((res) => {
				console.log(res)
				if (res.code == 200) {
					let arr = res.data.records;
					arr.forEach((item) => {
						if (item.id == this.planId) {
							item.advantageTempArr = item.advantage.split(",");
							item.frameworkTempArr = item.framework.split(",");
							item.backgroundTempArr = item.background.split(",");
							this.detail = item;
						}
					});
				}
			});
		},
	},
};
</script>
<style lang="less" scoped>
.banner-box {
	margin-top: 60px;
	height: 440px;
}
.cad-box {
	display: flex;
	flex-direction: column;
	align-items: center;
	img {
		width: 1200px;
		margin-bottom: 40px;
	}
	.cad-imgs{
		width:1200px;
		margin:0 auto;
		img{
			&:nth-child(2n){
				width:588px;
				margin-bottom:24px;	
				margin-left:24px;			
			}
			&:nth-child(2n+1){
				width:588px;				
				margin-bottom:24px;
			}			
		}
	}
	.cad-title {
		font-size: 32px;
		color: #222222;
		font-weight: 700;
		margin: 80px 0 50px 0;
	}
	&:nth-child(2n) {
		background-color: #f5f8ff;
	}
	&:nth-child(2n + 1) {
		background-color: #fff;
	}
}
.good-box {
	width: 100%;
	padding-top: 40px;
	text-align: center;
	&:nth-child(2n) {
		background-color: #fff;
	}
	&:nth-child(2n + 1) {
		background-color: #f5f8ff;
	}
	&:last-child {
		padding-bottom: 40px;
	}
}
.s-name{	
	font-family: Source Han Sans, Source Han Sans;
	font-weight: 700;
	font-size: 32px;
	color: #222222;	
}
.s-desc{
	padding-top:30px;
	width: 522px;
	height: 108px;
	font-family: Source Han Sans, Source Han Sans;
	font-weight: 400;
	font-size: 18px;
	color: #7C8CAC;
	line-height: 26px;
	text-align: justify;
	font-style: normal;
	text-transform: none;
}
</style>
